export const sidebarSongsMap = {
      'Abscond' : [
            [
            "before i wake",
            "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/abscond+-+before+i+wake+(demo).mp3",
            "abscond",
            "before i wake (demo)",
            "5" 
            ],  [
              "FAUST",
              "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/abscond+-+FAUST.mp3",
              "abscond",
              "",
              ""
            ],
            [
              "RUN",
              "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/RUN+-+AMBEDO+EXCERPT+01_03.mp3",
              "abscond",
              "RUN - AMBEDO EXCERPT 01_03",
              "5"

            ],
            [
              "+BRIIIIIIITE",
              "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/abscvnd/abscond+-+%2BBRIIIIIIITE.mp3",
              "abscond",
              "",
              ""
            ],
          ],
      'BabyGlobin': [
              [
                "48 Subs",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/BabyGlobin/48+Subs+Mix.mp3",
                "BabyGlobin",
                "48 Subs ft. Noturlover",
                ""
            
              ],
              [
                "Hurry Up",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/BabyGlobin/BabyGlobin+-+Hurry+Up.mp3",
                "BabyGlobin",
                "Hurry Up",
                "2"
              ],
              [
                "RESTART",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/BabyGlobin/BabyGlobin+-+RESTART.mp3",
                "BabyGlobin",
                "RESTART",
                "2"
                
              ]
            ],

      'Chai Sully': [
                [
                  "Tangerine",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Chai/Chai+-+Tangerine+-+good+quality.mp3",
                  "Chai",
                  "Tangerine",
                  "1"
                ]
              ],
      'JnJKharia': [

                [
                  "vexed.",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/JnJKhaira+-+vexed.mp3",
                  "JnJKhaira",
                  "vexed.",
                  ""
                ],
                
                [
                 "blundell.",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/blundell.wav",
                  "JnJKhaira",
                  "blundell. (Unreleased)",
                  "0"
              
                ],
                [
                  "earth strong.",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/earth+strong.wav",
                  "JnJKhaira",
                  "earth strong. (Unreleased)",
                  ""
                ],
                [
                  "humdila",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/jnjkhaira/humdila.wav",
                  "JnJKhaira",
                  "humdila (Unreleased)",
                  "0"
              
                ]
              ],
      'Noturlover': [
                [
                  "Slide",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Noturlover/Slide+-+Noturlover+(P.+Bakedboi).mp3",
                  "Noturlover (P. Bakedboi)",
                  "",
                  ""
                ],
                [
                  "Ayana",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Noturlover/Noturlover+-+Ayana+(prod+by+dax).mp3",
                  "Noturlover",
                  "Ayana (prod by dax)",
                  "3"
                ],
                [
                  "Mood Right",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Noturlover/Noturlover+-+MOOD+RIGHT+(prod+by+svnred+%2B+bakedboi).mp3",
                  "Noturlover",
                  "Mood Right (prod by svnred + bakedboi)",
                  "4"
                ],

              ],
      'Rod Lowkey': [
                [
                  "97'",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+97'+feat.+Art+Of+Max+(Prod.+Juno).mp3",
                  "ROD LOWKEY",
                  "97' feat. Art Of Max (Prod. Juno)",
                  "6"
          
                ],
                [
                  "Hip Hop",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+Hip+Hop+feat.+DRAZI+(Prod.+Tek.Lun).mp3",
                  "ROD LOWKEY",
                  "Hip Hop feat. DRAZI",
                  "4"
  
                ],
                [
                  "Speak Yo",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+Speak+Yo+Shit+(Prod.+Ahwlee+%26+Dimijay).mp3",
                  "ROD LOWKEY",
                  "Speak Yo Shit",
                  "4"
          
                ],
                [
                  "Babies",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/ROD+LOWKEY+-+Babies+and+Fools+(R.O.D+Mix).mp3",
                  "ROD LOWKEY",
                  "Babies and Fools (R.O.D. Mix)",
                  ""
          
                ],
                [
                  "Smooth",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Rod+Lowkey/SMOOTH+SHIT+X+ROD+LOWKEY.mp3",
                  "ROD LOWKEY",
                  "Smooth Shit (Unreleased)",
                  ""
                ],
              ],
      'Selah': [
                
                [
                  "bloom",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/selah+-+bloom+interlude.mp3+%5Bdemo%3F%5D.mp3",
                  "Selah",
                  "bloom interlude (demo)",
                  "9"
                ],
                [
                  "ATTEMPTS",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/selah+-+FAILED+ATTEMPTS.mp3",
                  "Selah",
                  "FAILED ATTEMPTS",
                  ""
                ],
                [
                  "water",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/selah+-+water.mp3",
                  "Selah",
                  "water",
                  "8"
                ],
                [
                  "l.m.n.",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Selah/Kid+Smoko+%26+Selah+-+Like+Me+Now-1.mp3",
                  "Kid Smoko & Selah",
                  "Like Me Now",
                  ""
                ],


              ],
      'Bloodroot': [
                [
                  "Audrey",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Bloodroot/Bloodroot+-+Audrey.mp3",
                  "Bloodroot",
                  "",
                  ""
                ],
                [
                  "Fool",
                  "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Bloodroot/Bloodroot+-+Fool.mp3",
                  "Bloodroot",
                  "",
                  ""
                ],
              ],
       'Raleighrain':[
              [
                "charms",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/raleighrain/raleighrain+-+charms.mp3",
                "raleighrain",
                "",
                ""
              ],
              [
                "bloo",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/raleighrain/raleighrain+-+bloo.mp3",
                "raleighrain",
                "",
                ""
              ],
              [
                "Jerry n Georgie",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Matt+Brade/raleigh%26matt+brade+-+jerry+n+georgie.mp3",
                "raleigh & matt brade",
                "",
                ""
              ]
            ],
      'Purple Corporation': [
              [
                "Fish Out of Water",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Purple+Corporation/Purple+Corporation+-+Fish+Out+of+Water.mp3",
                "Purple Corporation",
                "",
                "7",
              ],
              [
                "Gamma Riders",
                "https://ramenshopradio.s3-us-west-2.amazonaws.com/Tracks/Homie+Tracks/Purple+Corporation/Purple+Corporation+-+Gamma+Riders.mp3",
                "Purple Corporation",
                "",
                ""
              ]
            ]


          }
